"use client";

type MarqueeRowProps = {
  direction: "left" | "right";
  speed: number;
  children: React.ReactNode;
};

/**
 * Fila en desplazamiento continuo. El contenido se duplica y la animación
 * recorre el 50% del ancho, de modo que el bucle no tiene salto visible.
 * La copia duplicada queda fuera del árbol de accesibilidad.
 */
export default function MarqueeRow({
  direction,
  speed,
  children,
}: MarqueeRowProps) {
  return (
    <div className="relative overflow-hidden">
      <div
        className="flex w-max marquee-track"
        style={{
          animationName: `stats-scroll-${direction}`,
          animationDuration: `${speed}s`,
        }}
      >
        <div className="flex items-stretch shrink-0">{children}</div>
        <div className="flex items-stretch shrink-0" aria-hidden="true">
          {children}
        </div>
      </div>

      <style jsx>{`
        .marquee-track {
          animation-timing-function: linear;
          animation-iteration-count: infinite;
        }
        @keyframes stats-scroll-left {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }
        @keyframes stats-scroll-right {
          from {
            transform: translateX(-50%);
          }
          to {
            transform: translateX(0);
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee-track {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
}
